export const globalServicesManager = {
  header: {
    title: "Servicios y experiencias",
    description: "Una sola lista para toda tu cuenta. Escribe cada servicio una vez y marca en qué anuncios se ofrece.",
  },

  toolbar: {
    info: "Lo que crees aquí sale en tu <strong>motor de reservas</strong> y en tu <strong>web</strong>, en los anuncios que marques.",
    newService: "Nuevo servicio",
  },

  loading: "Cargando servicios…",

  empty: {
    title: "Todavía no tienes servicios",
    description: "Un traslado, una visita guiada, una cesta de bienvenida… El huésped los añade al reservar.",
    create: "Crear el primero",
  },

  status: {
    active: "Activo",
    paused: "Pausado",
  },

  price: {
    onRequest: "A consultar",
    free: "Gratis",
  },

  assign: {
    title: "En qué anuncios se ofrece",
    listingsLabel: "Tus anuncios",
    selectAll: "Seleccionar todos",
    clearAll: "Quitar todos",
    inAll: "En todos los anuncios",
    inSome: "En {n} de {total}",
    units: "{n} unidades",
    pickRooms: "Elegir habitaciones",
    hideRooms: "Ocultar habitaciones",
    roomsHint: "Marca solo las habitaciones donde se ofrece. Sin marcar ninguna, se ofrece en todas.",
    inRooms: "En 1 habitación | En {count} habitaciones",
    unassigned: "Sin asignar",
    helperNone: "Sin marcar nada, este servicio NO se ofrece en ningún sitio.",
    roomsChecked: "1 marcada · quitar | {count} marcadas · quitar",
    andMore: "+1 más | +{count} más",
    helper: "Sin marcar ninguno, el servicio se ofrece en todos tus anuncios.",
  },

  actions: {
    edit: "Editar",
    delete: "Eliminar",
    cancel: "Cancelar",
    save: "Guardar",
  },

  delete: {
    title: "Eliminar el servicio",
    text: "«{name}» dejará de ofrecerse en todos tus anuncios. No se puede deshacer.",
    accept: "Sí, eliminar",
  },

  saved: {
    assign: "Anuncios actualizados",
    state: "Servicio actualizado",
    deleted: "Servicio eliminado",
  },

  errors: {
    load: "No hemos podido cargar tus servicios.",
    assign: "No hemos podido guardar los anuncios.",
    state: "No hemos podido cambiar el servicio.",
    delete: "No hemos podido eliminar el servicio.",
  },
};
